var IconButtonVariant;
(function (IconButtonVariant) {
    IconButtonVariant["default"] = "default";
    IconButtonVariant["ghost"] = "ghost";
    IconButtonVariant["pagination"] = "pagination";
    IconButtonVariant["secondary"] = "secondary";
})(IconButtonVariant || (IconButtonVariant = {}));

export { IconButtonVariant };
